(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function mobileToggler(x) {
    if (x.matches) {
      document.querySelectorAll('.mobile-toggler').forEach(item => item.addEventListener('click', (event) => {
        event.preventDefault();
        let toggler = event.currentTarget.classList;
        toggler.contains('toggled') ? toggler.remove('toggled') : toggler.add('toggled');
      }));
    }
  }
  var x = window.matchMedia("(max-width: 991px)")
  mobileToggler(x);
  x.addListener(mobileToggler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('section-header--container');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) {
        console.warn('Header element not found for IntersectionObserver');
        return;
      }

      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-form"]) return;
  try {
    
  function serializeJSON(form) {
    const formData = new FormData(form);
    const pairs = {}
    const consistent = {};
    for (const [name, value] of formData) {
      if(value === null || value === '' || JSON.stringify(value) === '{}') {
        continue
      } else if (name == 'form_type' || name == 'utf8') {
        consistent[name] = value;
      } else {
        pairs[name] = value;
      }
    }
    return JSON.stringify({ consistent, data: pairs }, null, 2);
  }
  
  class FormBuilder extends HTMLElement {
    constructor() {
      super();
      this.form = document.querySelector('#pro-form');
      this.thanks = document.querySelector('#thanks');
      this.form_submit = document.getElementById('custom-form-submit');
  
      if(!this.form) return;
  
      this.form.addEventListener('submit', this.formSubmit.bind(this));
      this.querySelectorAll('.field__input-file').forEach(
        (input) => input.addEventListener('change', this.onFileInput.bind(this))
      );
    }
  
    onFileInput(event) {
      const input = event.target;
      const file_link = input.nextElementSibling;
      if( input.files ) {
        this.form_submit.classList.add('button--loading');
        this.form_submit.disabled = true;
  
        const file = input.files[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('document', this.form_submit.dataset.source);
  
        var res = Array.from(formData.entries(), ([key, prop]) => (
          {[key]: {
            "ContentLength":
            typeof prop === "string"
            ? prop.length
            : prop.size
          }
          }
        ));
  
        if (file.size > 5000000) {
          alert('File size too large, please reduce file size and resubmit');
          input.value = '';
        } else {

          alert('Form is not currently set up for file upload');
          input.value = '';
          /*
            fetch('https://hook.us1.make.com/2uytqypv4tgk945njxndndq348ujhkc3', {
              method: 'POST',
              body: formData
            })
            .then(response => response.text())
            .then(data => {
              file_link.value = data;
              this.form_submit.classList.remove('button--loading');
              document.getElementById('custom-form-submit').disabled = false;
            })
            .catch((error) => {
              this.form_submit.classList.remove('button--loading');
              document.getElementById('custom-form-submit').disabled = false;
            });
          */
          
        }
      }
    }
  
    formSubmit(event) {
      event.preventDefault();
      this.form_submit.classList.add('animate');
      let redirect_url;
      if(this.hasAttribute('data-redirect')) {
        redirect_url = this.dataset.redirect;
      }
      fetch(this.dataset.send, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: serializeJSON(this.form)
      })
      .then(response => response.json())
      .then(data => {
        var form_error = document.getElementById('form_error');
        if(!form_error) {
          form_error = document.createElement('div');
          form_error.id = 'form_error';
          this.form_submit.parentNode.insertBefore(form_error, this.form_submit.nextSibling);
        }
        this.form_submit.classList.remove('animate');
        this.form_submit.classList.add('success');
        setTimeout(function(){
          this.form.classList.add('hidden');
          this.thanks.classList.remove('hidden');
          window.scrollTo({ top: 0, behavior: 'smooth' });
          if(data.success) {
            if(redirect_url) {
              setTimeout(function(){
                window.location.href = redirect_url;
              },500);
            }
          } else {
            form_error.innerText = data.reason;
          }
        }.bind(this),500);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.form_submit.classList.remove('animate');
        this.form_submit.classList.add('error');
      });
    }
  }
  
  customElements.define('form-builder', FormBuilder)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
